import { AxiosResponse } from 'axios'
import {
  ApiSuccessResponse,
  BaseTableRequest,
  Certificate,
  CertificateHistoryRequest,
  CertificateHistoryRow,
  CertificateRule,
  CertificateRuleCreateRequest,
  CertificateRuleEditRequest,
  CertificateType,
  RequestById,
  Response,
  TableResponse,
} from 'types'
import axiosInstance from './axios'

export const getCertificates = (): Promise<Response<Certificate[]>> => {
  return axiosInstance.post('/certificates')
}

export const downloadCertificate = (request: {
  id: number
  type: CertificateType
  timezone: string
}): Promise<AxiosResponse<ArrayBuffer>> => {
  return axiosInstance.post('/certificates/download', request, { responseType: 'arraybuffer' })
}

export const downloadMainCertificate = (request: {
  timezone: string
}): Promise<AxiosResponse<ArrayBuffer>> => {
  return axiosInstance.post('/certificates/download-report', request, {
    responseType: 'arraybuffer',
  })
}

export const downloadAdminCertificate = (request: {
  id: number
  type: CertificateType
  timezone: string
}): Promise<AxiosResponse<ArrayBuffer>> => {
  return axiosInstance.post('/certificates/download', request, { responseType: 'arraybuffer' })
}

export const getCertificatesRules = (request: BaseTableRequest) => {
  return axiosInstance.post<BaseTableRequest, TableResponse<CertificateRule>>(
    '/certificate-rules',
    request,
  )
}

export const getCertificateRuleById = (
  request: RequestById,
): Promise<Response<CertificateRule>> => {
  return axiosInstance.post('/certificate-rules/read', request)
}

export const createCertificateRule = (request: CertificateRuleCreateRequest) => {
  return axiosInstance.post('/certificate-rules/create', request)
}

export const editCertificateRule = (request: CertificateRuleEditRequest) => {
  return axiosInstance.post('/certificate-rules/update', request)
}

export const checkCertificateRuleName = async (name: string): Promise<boolean> => {
  const result: AxiosResponse<ApiSuccessResponse> = await axiosInstance.post(
    '/certificate-rules/check-name',
    { name },
  )

  return result.data.success
}

export const deleteCertificateRule = (request: RequestById): Promise<unknown> => {
  return axiosInstance.post('/certificate-rules/delete', request)
}

export const getCertificateHistory = (
  request: CertificateHistoryRequest,
): Promise<TableResponse<CertificateHistoryRow>> => {
  return axiosInstance.post('/certificate-rules/histories', request)
}
